@let isAirfield = (location() === 'airfield');

@if (isAirfield) {
<h1>Weather at Troll Airfield</h1>
} @else {
<h1>Weather at Troll research station</h1>
}

<p>Meteorological data collected at Troll research station and airfield (Dronning Maud Land - Antarctica) as documented by <a routerLink="/dataset/79d4b7c7-3bee-40a6-975f-f9ed4d253c44">this dataset</a>.</p>

<h2>Latest measurements</h2>
@switch (latest.status()) {
  @case('error') {
    <p>Error: {{latest.error()?.message}}</p>
  }
  @case('resolved') {
    @if (latest.hasValue()) {
      @let measurement = latest.value();
      <div class="latest">
        <app-troll-current
          [measurement]="measurement">
        </app-troll-current>
        <div class="latest__compass">
          <div>
            <app-troll-compass
              [degrees]="[measurement.windDirectionTrue, measurement.windDirectionMagnetic]">
            </app-troll-compass>
          </div>
          <p>
            Magnetic (long needle) and true (short needle) wind directions.
          </p>
        </div>
      </div>
    }
  }
  @default {
    <p>Loading latest measurements, please wait...</p>
  }
}

@switch (measurements.status()) {
  @case('error') {
    <p>Error: {{measurements.error()?.message}}</p>
  }
  @case('resolved') {
    @if (measurements.hasValue()) {
      <h2>Wind speed, direction, and gust </h2>
      <app-troll-chart
        [measurements]="measurements.value()"
        [datasets]="isAirfield ? ['windSpeedKnots','windGustKnots','windDirectionMagnetic'] : ['windSpeedMs','windGustMs','windDirectionTrue']">
      </app-troll-chart>

      <h2>Air temperature and dew point</h2>
      <app-troll-chart
        [measurements]="measurements.value()"
        [datasets]="['airTemperature','dewPoint']">
      </app-troll-chart>

      <h2>Pressure (QNH)</h2>
      <app-troll-chart
        [measurements]="measurements.value()"
        [datasets]="['pressure']">
      </app-troll-chart>
    }
  }
  @default {
    <p>Loading chart data, please wait...</p>
  }
}
